import React, { useEffect, useState } from 'react'
import { IPD_PROJECT_ID } from '../../../utils/constants'
import SxpForm from '../../../form/SxpForm'
import { useParams } from 'react-router-dom'
import RenderOnRole from '../../../components/RenderOnRole'
import { DIAGNOSIS_READ, DIAGNOSIS_WRITE } from '../../../utils/roles'
import KeycloakService from '../../../utils/keycloakService'
import { startSxpProxy } from '../../../utils/api'
import SxpElement from '../../../form/SxpElement'

const IpdTreatmentPlan = () => {
  const { id } = useParams()
  // const [key, setKey] = useState(Date.now())
  const [status, setStatus] = useState(false)
  useEffect(() => {
    startSxpProxy(IPD_PROJECT_ID, 'getEncounterById', { encounterId: id }).then(
      (data) => {
        const status =
          data?.data?.statusHistory?.[0]?.status === 'finished' ||
          data?.data?.statusHistory?.[0]?.status === 'cancelled'
            ? true
            : false
        setStatus(status)
      }
    )
  }, [id])

  return (
    <RenderOnRole
      roles={[DIAGNOSIS_READ, DIAGNOSIS_WRITE]}
      element={
        <SxpForm
          project={IPD_PROJECT_ID}
          intent='treatmentPlanForIPD'
          journeyState={{ encounterId: id }}
          canSubmit={
            status ? false : KeycloakService.hasRole([DIAGNOSIS_WRITE])
          }
          // onJourneyEnd={() => setKey(Date.now())}
        >
          <SxpElement reference='treatmentPlan' />
          <SxpElement reference='referralRequired' />
          <SxpElement reference='nameOfDoctor' />
          <SxpElement disabled reference='department' />
          <SxpElement reference='reasonReferral' />
        </SxpForm>
      }
    />
  )
}

export default IpdTreatmentPlan
